import { bandOf, barFill, rankOf, type Guess } from "../../worker/lib/game";

const BAND_CLASS = { green: "bg-bar-green", yellow: "bg-bar-yellow", red: "bg-bar-red" } as const;

export function GuessRow({ guess, pinned = false }: { guess: Guess; pinned?: boolean }) {
  const band = bandOf(guess.d);
  const fill = Math.round(barFill(guess.d) * 100);
  return (
    <div
      className={`relative overflow-hidden rounded-lg ${pinned ? "ring-2 ring-tgtext/40" : ""}`}
      style={{ background: "var(--bar-track)" }}
    >
      <div
        className={`absolute inset-y-0 left-0 ${BAND_CLASS[band]} opacity-90`}
        style={{ width: `${guess.d === 0 ? 100 : fill}%` }}
      />
      <div className="relative flex items-center justify-between px-3 py-[9px] text-[15px] font-semibold">
        <span className="truncate">
          {guess.t ? <span className="mr-1 opacity-70">💡</span> : null}
          {guess.w}
        </span>
        <span className="ml-3 tabular-nums">{guess.d === 0 ? "1 ✓" : rankOf(guess.d)}</span>
      </div>
    </div>
  );
}
